import BaseModal from "../../../components/ui/BaseModal";
import BaseTextField from "../../../components/ui/BaseTextField";
import BaseButton from "../../../components/ui/BaseButton";
import BaseAutoSelect from "../../../components/ui/BaseAutoSelect";
import { CurrencySymbol, UserType } from "../../../utils/enum";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  createInvoice,
  updateInvoiceNote,
} from "../../../services/api/invoice";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { showToast } from "../../../store/toast/toastSlice";
import { useNavigate, useParams } from "react-router-dom";
import { fetchAllBankAccountsByBranch } from "../../../services/api/bankAccount";
import { useEffect, useRef, useState } from "react";
import { fetchCompanyBranches } from "../../../services/api/branch";

const validationSchema = yup.object({
  comment: yup.string().required("note is required"),
});

const AddInvoiceNoteModal = ({
  invoice,
  refetchInvoiceDetails,
  open,
  close,
}) => {
  console.log("invoice", invoice);

  const formik = useFormik({
    initialValues: {
      comment: invoice?.comment,
    },
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      handleAddNoteButton();
    },
    validateOnChange: true,
    validateOnBlur: true,
    enableReinitialize: true,
  });

  const {
    isPending: isUpdateInvoiceNoteApiLoading,
    mutateAsync: updateInvoiceNoteMutation,
  } = useMutation({
    mutationFn: updateInvoiceNote,
  });

  const handleAddNoteButton = async () => {
    try {
      await updateInvoiceNoteMutation({
        id: invoice.id,
        comment: formik.values.comment,
      });

      close(false);
      refetchInvoiceDetails();
    } catch (error) {}
  };
  return (
    <BaseModal
      className="-top-[200px] overflow-auto"
      open={open}
      close={() => {
        close(false);

        // formik.resetForm();
      }}
    >
      <div className="py-7 px-12 xl:w-[1000px] lg:w-[900px] sm:w-[700px]">
        <h6 className="text-dark font-normal border-b pb-1">Add Note</h6>

        <textarea
          className="w-full border rounded-md mt-4 h-48 p-2 text-[13px]"
          id="comment"
          name="comment"
          type="number"
          value={formik.values.comment}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.comment && Boolean(formik.errors.comment)}
          helperText={formik.touched.comment && formik.errors.comment}
        />
      </div>

      <div
        className="d-flex content-center bg-white py-6 "
        style={{
          boxShadow: "0px 0px 14px 0px rgba(0, 0, 0, 0.07)",
        }}
      >
        <BaseButton
          className=" px-[28px] py-[5px] bg-light text-primary hover:!text-primary"
          variant="outlined"
          color="primary"
          style={{
            marginRight: "16px",
          }}
          onClick={() => {
            close(false);
            /* setSelectedEmployment(null);
              formik.resetForm(); */
          }}
        >
          Cancel
        </BaseButton>

        <BaseButton
          isLoading={isUpdateInvoiceNoteApiLoading}
          disabled={!formik.isValid || !formik.dirty}
          loaderSize={24}
          loaderColor="primary"
          className="px-[40px] py-[5px]"
          color="primary"
          onClick={formik.handleSubmit}
        >
          Save
        </BaseButton>
      </div>
    </BaseModal>
  );
};

export default AddInvoiceNoteModal;
